<template>
  <span class="count-down-timer" v-if="inline">{{ countDownDisplay }}</span>
  <article
    v-else
    class="count-down-timer"
    :class="{ 'bloop-animation': doBloopAnimation }"
  >
    <p>{{ countDownDisplay }}</p>
  </article>
</template>

<script>
import countdown from '../mixins/countdown'

/**
 * A countdown component that takes either two timestamps (in milliseconds) and counts the duration of those 2,
 * or takes an end timestamp and counts down from current present time.
 */
export default {
  name: 'CountDown',
  mixins: [countdown],
  props: {
    inline: Boolean,
    enableBloopAnimations: Boolean,
  },
  data() {
    return {
      doBloopAnimation: false,
      countDownFinished: false,
    }
  },
  methods: {
    /**
     * gets the time representation of the current count down
     * @param {number} startTimeStamp
     * @param {number} endTimeStamp
     * @returns {string} Ex: 11:11
     */
    getTimeDisplay(startTimeStamp, endTimeStamp) {
      const remainingMinutes = this.remainingMinutes(
        startTimeStamp,
        endTimeStamp
      )

      const remainingSeconds = this.remainingSeconds(
        startTimeStamp,
        endTimeStamp
      )

      if (
        this.enableBloopAnimations &&
        remainingMinutes === 0 &&
        remainingSeconds <= 3 &&
        !this.countDownFinished
      ) {
        // Does a "bloop" animation on every count down, 3 seconds before finish time, to give a sense of urgency.
        this.doBloopAnimation = true
        setTimeout(() => {
          this.doBloopAnimation = false
        }, 150)
      }

      return `${remainingMinutes}:${remainingSeconds}`
    },
  },
  computed: {
    countDownDisplay() {
      return this.getTimeDisplay(this.countDownPosition, this.endTimeStamp)
    },
  },
}
</script>

<style lang="scss" scoped>
article.count-down-timer {
  > p {
    margin: 0;
    line-height: normal;
    transition: all 0.15s ease-in-out;
  }

  &.bloop-animation {
    > p {
      transform: scale(1.2);
    }
  }
}
</style>
